"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatterDateSql = formatterDateSql;
exports.formatterDate = formatterDate;
exports.formatterDateTexte = formatterDateTexte;
exports.formatterDateRelative = formatterDateRelative;
exports.estDateValide = estDateValide;
exports.formaterDateHeureCourante = formaterDateHeureCourante;
exports.formaterDateJourHeureArobas = formaterDateJourHeureArobas;

var _utilitaires = require("./utilitaires");

Date.prototype.isDate = function () {
  return this.toString() !== "Invalid Date";
};

function formaterNombre(n) {
  var s = n.toString();
  return s.length < 2 ? '0' + s : s;
}

function formatterDateSql(date) {
  if (!date.getMonth) {
    if (estDateValide(date)) {
      date = new Date(date);
    } else {
      return '';
    }
  }

  var mois = {
    0: 'JAN',
    1: 'FEB',
    2: 'MAR',
    3: 'APR',
    4: 'MAY',
    5: 'JUN',
    6: 'JUL',
    7: 'AUG',
    8: 'SEP',
    9: 'OCT',
    10: 'NOV',
    11: 'DEC'
  }[date.getMonth()];
  return "".concat(date.getFullYear(), "-").concat(mois, "-").concat(formaterNombre(date.getDate()), " ").concat(formaterNombre(date.getHours()), ":").concat(formaterNombre(date.getMinutes()), ":").concat(formaterNombre(date.getSeconds()));
}

function formatterDate(date, ajouterHeureMinuteSeconde) {
  var pad = function pad(s) {
    return s.length < 2 ? '0' + s : s;
  };

  var partieDate = "".concat(date.getFullYear(), "-").concat(pad((date.getMonth() + 1).toString()), "-").concat(pad(date.getDate().toString()));
  var partieHeure = '';

  try {
    if (ajouterHeureMinuteSeconde) {
      partieHeure = " ".concat(date.getHours(), ":").concat(pad(date.getMinutes().toString()), ":").concat(pad(date.getSeconds().toString()));
    }
  } catch (e) {
    partieHeure = '';
  }

  return partieDate + partieHeure;
}

function obtenirMois(date) {
  if (!(0, _utilitaires.estDefini)(date, 'getMonth')) {
    return null;
  }

  return {
    0: 'Janvier',
    1: "F\xE9vrier",
    2: 'Mars',
    3: 'Avril',
    4: 'Mai',
    5: 'Juin',
    6: 'Juillet',
    7: 'Août',
    8: 'Septembre',
    9: 'Octobre',
    10: 'Novembre',
    11: "D\xE9cembre"
  }[date.getMonth()];
}

function formatterDateTexte(date) {
  if (!(0, _utilitaires.estDefini)(date) || !date.getMonth) {
    if (estDateValide(date)) {
      date = new Date(date);
    } else {
      return '';
    }
  }

  var pad = function pad(s) {
    return s.length < 2 ? '0' + s : s;
  };

  var mois = obtenirMois(date);
  return "".concat(pad(date.getDate().toString()), "\xA0").concat(mois, "\xA0").concat(date.getFullYear());
}

function formatterDateRelative(date) {
  var difference = new Date() - date;

  if (difference < 0) {
    return formatterDate(date);
  }

  var tests = [{
    cle: 'seconde',
    temps: 1000,
    limite: 60
  }, {
    cle: 'minute',
    temps: 1000 * 60,
    limite: 60
  }, {
    cle: 'heure',
    temps: 1000 * 60 * 60,
    limite: 24
  }, {
    cle: 'jour',
    temps: 1000 * 60 * 60 * 24,
    limite: 7
  }];
  var valeurRelative;
  tests.some(function (test) {
    var valeur = Math.floor(difference / test.temps);

    if (valeur < test.limite) {
      valeurRelative = "Il y a ".concat(valeur, " ").concat(test.cle).concat(valeur > 1 ? 's' : '');
      return true;
    }
  });

  if ((0, _utilitaires.estDefini)(valeurRelative)) {
    return valeurRelative;
  }

  return formatterDate(date);
}

function estDateValide(date) {
  try {
    if (new Date(date).isDate()) {
      return true;
    }
  } catch (err) {}

  return false;
}

function formaterDateHeureCourante(date) {
  var optionsDate = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour12: false
  };
  var optionsHeure = {
    hour12: false
  };

  try {
    if (estDateValide(date)) {
      return date.toLocaleDateString('fr-FR', optionsDate) + ' ' + date.toLocaleTimeString('fr-FR', optionsHeure);
    }
  } catch (e) {
    return "Format de date invalide";
  }

  return new Date().toLocaleDateString('fr-FR', optionsDate) + ' ' + new Date().toLocaleTimeString('fr-FR', optionsHeure);
}

function formaterDateJourHeureArobas(date) {
  if (!estDateValide(date)) {
    return null;
  }

  var jour = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'][date.getDay()];
  var mois = obtenirMois(date);
  return "".concat(jour, " ").concat(date.getDate(), " ").concat(mois, " ").concat(date.getFullYear(), " @ ").concat(formaterNombre(date.getHours()), "h").concat(formaterNombre(date.getMinutes()));
}